import { JSX } from 'react';

import { useTimer } from 'hooks';

type TimerProps = {
	seconds: number;
	onEnd: () => void;
	render: (v: number) => JSX.Element;
};

export const Timer = ({ seconds, onEnd, render }: TimerProps) => {
	const { time } = useTimer(seconds, onEnd);

	return render(time);
};
